import { displayMessage } from '../../Helpers/Utilities';
import { IPerformanceReportItemValue } from '../../Models/PerformanceReportItemValue';
import { showAlert } from '../Notifications/actions';
import { IPerformanceReport } from './../../Models/PerformanceReport';

// export const LOAD_PERFORMANCEREPORT = 'LOAD_PERFORMANCEREPORT';
// export const LOAD_PERFORMANCEREPORT_SUCCESS = 'LOAD_PERFORMANCEREPORT_SUCCESS';
export const CREATE_PERFORMANCE_REPORT = 'CREATE_PERFORMANCE_REPORT';
export const CREATE_PERFORMANCE_REPORT_SUCCESS = 'CREATE_PERFORMANCE_REPORT_SUCCESS';

export const ROLLUP_PERFORMANCEREPORT = 'ROLLUP_PERFORMANCEREPORT';
export const ROLLUP_PERFORMANCEREPORT_SUCCESS = 'ROLLUP_PERFORMANCEREPORT_SUCCESS';
export const ROLLUP_PERFORMANCEREPORT_FAILURE = 'ROLLUP_PERFORMANCEREPORT_FAILURE';

/************************   Begin PerformanceReport    ******************************/

// CREATE
export interface CreatePerformanceReportAction {
  type: typeof CREATE_PERFORMANCE_REPORT;
  payload: { month: number, year: number, businessTypeId: string, clientId: string | null, captureDataFromChildren?: boolean };
}
export const createPerformanceReport = (month: number, year: number, businessTypeId: string, clientId: string | null, captureDataFromChildren?: boolean): CreatePerformanceReportAction => {
  return {
    type: CREATE_PERFORMANCE_REPORT,
    payload: {month, year, businessTypeId, clientId, captureDataFromChildren}
  };
}
export interface CreatePerformanceReportSuccessAction {
  type: typeof CREATE_PERFORMANCE_REPORT_SUCCESS;
  payload: { performanceReport: IPerformanceReport };
}
export const createPerformanceReportSuccess = (performanceReport: IPerformanceReport): CreatePerformanceReportSuccessAction => {
  return {
    type: CREATE_PERFORMANCE_REPORT_SUCCESS,
    payload: { performanceReport }
  };
}

// Load performance report
export const LOAD_PERFORMANCE_REPORT = 'LOAD_PERFORMANCE_REPORT';
export const LOAD_PERFORMANCE_REPORT_SUCCESS = 'LOAD_PERFORMANCE_REPORT_SUCCESS';

export interface LoadPerformanceReportAction {
  type: typeof LOAD_PERFORMANCE_REPORT;
  payload: { id: string };
}
export const loadPerformanceReport = (id: string): LoadPerformanceReportAction => {
  return {
    type: LOAD_PERFORMANCE_REPORT,
    payload: { id }
  };
}
export interface LoadPerformanceReportSuccessAction {
  type: typeof LOAD_PERFORMANCE_REPORT_SUCCESS;
  payload: { performanceReport: IPerformanceReport };
}
export const loadPerformanceReportSuccess = (performanceReport: IPerformanceReport): LoadPerformanceReportSuccessAction => {
  return {
    type: LOAD_PERFORMANCE_REPORT_SUCCESS,
    payload: { performanceReport }
  };
}




// Dealer Reports
export const LOAD_DEALER_REPORTS = 'LOAD_DEALER_REPORTS';
export const LOAD_DEALER_REPORTS_SUCCESS = 'LOAD_DEALER_REPORTS_SUCCESS';

export interface LoadDealerReportsAction {
  type: typeof LOAD_DEALER_REPORTS;
  payload: { clientId: string };
}
export const loadDealerReports = (clientId: string): LoadDealerReportsAction => {
  return {
    type: LOAD_DEALER_REPORTS,
    payload: { clientId }
  };
}
export interface LoadDealerReportsSuccessAction {
  type: typeof LOAD_DEALER_REPORTS_SUCCESS;
  payload: { dealerReports: any[] };
}
export const loadDealerReportsSuccess = (dealerReports: any[]): LoadDealerReportsSuccessAction => {
  return {
    type: LOAD_DEALER_REPORTS_SUCCESS,
    payload: { dealerReports }
  };
}

// Close Performance Report
export const CLOSE_PERFORMANCE_REPORT = 'CLOSE_PERFORMANCE_REPORT';

export interface ClosePerformanceReportAction {
  type: typeof CLOSE_PERFORMANCE_REPORT;
}
export const closePerformanceReport = (): ClosePerformanceReportAction => {
  return {
    type: CLOSE_PERFORMANCE_REPORT
  };
}

// All Dealer Reports
export const LOAD_ALL_DEALER_REPORTS = 'LOAD_ALL_DEALER_REPORTS';
export const LOAD_ALL_DEALER_REPORTS_SUCCESS = 'LOAD_ALL_DEALER_REPORTS_SUCCESS';

export interface LoadAllDealerReportsAction {
  type: typeof LOAD_ALL_DEALER_REPORTS;
}
export const loadAllDealerReports = (): LoadAllDealerReportsAction => {
  return {
    type: LOAD_ALL_DEALER_REPORTS
  };
}
export interface LoadAllDealerReportsSuccessAction {
  type: typeof LOAD_ALL_DEALER_REPORTS_SUCCESS;
  payload: { dealerReports: any[] };
}
export const loadAllDealerReportsSuccess = (dealerReports: any[]): LoadAllDealerReportsSuccessAction => {
  return {
    type: LOAD_ALL_DEALER_REPORTS_SUCCESS,
    payload: { dealerReports }
  };
}



// LOAD
// export interface LoadPerformanceReportAction {
//   type: typeof LOAD_PERFORMANCEREPORT;
//   payload: {reportMonth: number, reportYear: number, clientId: string | null };
// }
// export const loadPerformanceReport = (reportMonth: number, reportYear: number, clientId: string | null): LoadPerformanceReportAction => {
//   return {
//     type: LOAD_PERFORMANCEREPORT,
//     payload: { reportMonth, reportYear, clientId }
//   };
// }
// export interface LoadPerformanceReportSuccessAction {
//   type: typeof LOAD_PERFORMANCEREPORT_SUCCESS;
//   payload: { performanceReport: IPerformanceReport };
// }
// export const loadPerformanceReportSuccess = (performanceReport: IPerformanceReport): LoadPerformanceReportSuccessAction => {
//   return {
//     type: LOAD_PERFORMANCEREPORT_SUCCESS,
//     payload: { performanceReport }
//   };
// }
export const CLEAR_LOADING_REPORT = 'CLEAR_LOADING_REPORT';

export interface ClearLoadingReportAction {
  type: typeof CLEAR_LOADING_REPORT;
}
export const clearLoadingReport = (): ClearLoadingReportAction => {
  return {
    type: CLEAR_LOADING_REPORT,
  };
}


export const SAVE_PERFORMANCEREPORT = 'SAVE_PERFORMANCEREPORT';
export const SAVE_PERFORMANCEREPORT_SUCCESS = 'SAVE_PERFORMANCEREPORT_SUCCESS';

export interface SavePerformanceReportAction {
  type: typeof SAVE_PERFORMANCEREPORT;
  payload: { performanceReport: IPerformanceReport };
}
export const savePerformanceReport = (performanceReport: IPerformanceReport): SavePerformanceReportAction => {
  return {
    type: SAVE_PERFORMANCEREPORT,
    payload: { performanceReport }
  };
}
export interface SavePerformanceReportSuccessAction {
  type: typeof SAVE_PERFORMANCEREPORT_SUCCESS;
  payload: { performanceReport: IPerformanceReport };
}
export const savePerformanceReportSuccess = (performanceReport: IPerformanceReport): SavePerformanceReportSuccessAction => {

  return {
    type: SAVE_PERFORMANCEREPORT_SUCCESS,
    payload: { performanceReport }
  };
}

export const SUBMIT_PERFORMANCEREPORT = 'SUBMIT_PERFORMANCEREPORT';
export const SUBMIT_PERFORMANCEREPORT_TAB = 'SUBMIT_PERFORMANCEREPORT_TAB';
export const SUBMIT_PERFORMANCEREPORT_SUCCESS = 'SUBMIT_PERFORMANCEREPORT_SUCCESS';
export const SUBMIT_PERFORMANCEREPORT_TAB_SUCCESS = 'SUBMIT_PERFORMANCEREPORT_TAB_SUCCESS';
export const UNLOCK_PERFORMANCEREPORT = 'UNLOCK_PERFORMANCEREPORT';
export const UNLOCK_PERFORMANCEREPORT_SUCCESS = 'UNLOCK_PERFORMANCEREPORT_SUCCESS';

export interface SubmitPerformanceReportAction {
  type: typeof SUBMIT_PERFORMANCEREPORT;
  payload: { performanceReport: IPerformanceReport };
}
export const submitPerformanceReport = (performanceReport: IPerformanceReport):  SubmitPerformanceReportAction => {
  return {
    type: SUBMIT_PERFORMANCEREPORT,
    payload: { performanceReport }
  };
}
export interface SubmitPerformanceReportSuccessAction {
  type: typeof SUBMIT_PERFORMANCEREPORT_SUCCESS;
  payload: { performanceReport: IPerformanceReport };
}
export const submitPerformanceReportSuccess = (performanceReport: IPerformanceReport): SubmitPerformanceReportSuccessAction => {
  return {
    type: SUBMIT_PERFORMANCEREPORT_SUCCESS,
    payload: { performanceReport }
  };
}


export interface UnlockPerformanceReportAction {
  type: typeof UNLOCK_PERFORMANCEREPORT;
  payload: { performanceReport: IPerformanceReport };
}
export const unlockPerformanceReport = (performanceReport: IPerformanceReport):  UnlockPerformanceReportAction => {
  return {
    type: UNLOCK_PERFORMANCEREPORT,
    payload: { performanceReport }
  };
}
export interface UnlockPerformanceReportSuccessAction {
  type: typeof UNLOCK_PERFORMANCEREPORT_SUCCESS;
  payload: { performanceReport: IPerformanceReport };
}
export const unlockPerformanceReportSuccess = (performanceReport: IPerformanceReport): UnlockPerformanceReportSuccessAction => {
  return {
    type: UNLOCK_PERFORMANCEREPORT_SUCCESS,
    payload: { performanceReport }
  };
}


export interface SubmitTabPerformanceReportAction {
  type: typeof SUBMIT_PERFORMANCEREPORT_TAB;
  payload: { performanceReport: IPerformanceReport, categoryId: string, statusId: string };
}
export const submitTabPerformanceReport = (performanceReport: IPerformanceReport, categoryId: string, statusId: string):  SubmitTabPerformanceReportAction => {
  return {
    type: SUBMIT_PERFORMANCEREPORT_TAB,
    payload: { performanceReport, categoryId, statusId }
  };
}

export interface SubmitTabPerformanceReportSuccessAction {
  type: typeof SUBMIT_PERFORMANCEREPORT_TAB_SUCCESS;
  payload: { performanceReport: IPerformanceReport, categoryId: string, includeStatus: boolean };
}
export const submitTabPerformanceReportSuccess = (performanceReport: IPerformanceReport, categoryId: string, includeStatus: boolean):  SubmitTabPerformanceReportSuccessAction => {
  return {
    type: SUBMIT_PERFORMANCEREPORT_TAB_SUCCESS,
    payload: { performanceReport, categoryId, includeStatus }
  };
}


export const UPDATE_PERFORMANCEREPORT_ITEM_VALUE = 'UPDATE_PERFORMANCEREPORT_ITEM_VALUE';
export interface UpdatePerformanceReportAction {
  type: typeof UPDATE_PERFORMANCEREPORT_ITEM_VALUE;
  payload: {itemId: string, fieldName: string, value: string | number | undefined | null};
}
export const updatePerformanceReport = (itemId:string, fieldName: string, value: string | number | undefined | null): UpdatePerformanceReportAction => {
  return {
    type: UPDATE_PERFORMANCEREPORT_ITEM_VALUE,
    payload: {itemId, fieldName, value }
  };
}

export const SET_SELECTED_CLIENT_ID = 'SET_SELECTED_CLIENT_ID';
export interface SetSelectedClientIdAction {
  type: typeof SET_SELECTED_CLIENT_ID;
  payload: {clientId: string | null}
}
export const setSelectedClientId = (clientId: string | null): SetSelectedClientIdAction => {
  return {
    type: SET_SELECTED_CLIENT_ID,
    payload: {clientId}
  }
}

export const LOAD_COMPLETED_PERFORMANCEREPORT_TABS = 'LOAD_COMPLETED_PERFORMANCEREPORT_TABS';
export interface LoadCompletedPerformanceReportTabsAction {
  type: typeof LOAD_COMPLETED_PERFORMANCEREPORT_TABS;
  payload: { id: string};
}
export const loadCompletedPerformanceReportTabs = (id: string): LoadCompletedPerformanceReportTabsAction => {
  return {
    type: LOAD_COMPLETED_PERFORMANCEREPORT_TABS,
    payload: {id}
  }
}
export const LOAD_COMPLETED_PERFORMANCEREPORT_TABS_SUCCESS = 'LOAD_COMPLETED_PERFORMANCEREPORT_TABS_SUCCESS';
export interface LoadCompletedPerformanceReportTabsSuccessAction {
  type: typeof LOAD_COMPLETED_PERFORMANCEREPORT_TABS_SUCCESS;
  payload: {completedCategoryIds: string[]}
}
export const loadCompletedPerformanceReportTabsSuccess = (completedCategoryIds: string[]): LoadCompletedPerformanceReportTabsSuccessAction => {
  return {
    type: LOAD_COMPLETED_PERFORMANCEREPORT_TABS_SUCCESS,
    payload: {completedCategoryIds}
  }
}


export const PRINT_BHPH_REPORT = 'PRINT_BHPH_REPORT';
export interface PrintBuyHerePayHereReportAction {
  type: typeof PRINT_BHPH_REPORT;
  payload: { month: number, year: number, clientId: string, isBlank?: boolean };
}
export const printBuyHerePayHerePerformanceReport = (month: number, year: number, clientId: string, isBlank?: boolean): PrintBuyHerePayHereReportAction => {
  return {
    type: PRINT_BHPH_REPORT,
    payload: {month, year, clientId, isBlank}
  };
}

export const PRINT_RETAIL_REPORT = 'PRINT_RETAIL_REPORT';
export interface PrintRetailReportAction {
  type: typeof PRINT_RETAIL_REPORT;
  payload: { month: number, year: number, clientId: string, isBlank?: boolean };
}
export const printRetailPerformanceReport = (month: number, year: number, clientId: string, isBlank?: boolean): PrintRetailReportAction => {
  return {
    type: PRINT_RETAIL_REPORT,
    payload: {month, year, clientId, isBlank}
  };
}


export interface RollupPerformanceReportAction {
  type: typeof ROLLUP_PERFORMANCEREPORT;
  payload: { reportId: string };
}
export const rollupPerformanceReport = (reportId: string): RollupPerformanceReportAction => ({
  type: ROLLUP_PERFORMANCEREPORT,
  payload: { reportId }
});

export interface RollupPerformanceReportSuccessAction {
  type: typeof ROLLUP_PERFORMANCEREPORT_SUCCESS;
}
export const rollupPerformanceReportSuccess = (): RollupPerformanceReportSuccessAction => ({
  type: ROLLUP_PERFORMANCEREPORT_SUCCESS
});

export interface RollupPerformanceReportFailureAction {
  type: typeof ROLLUP_PERFORMANCEREPORT_FAILURE;
  payload: { error: any };
}
export const rollupPerformanceReportFailure = (error: any): RollupPerformanceReportFailureAction => ({
  type: ROLLUP_PERFORMANCEREPORT_FAILURE,
  payload: { error }
});

/************************   End PerformanceReport    ******************************/

export type PerformanceReportAction = 
  LoadPerformanceReportAction
  | LoadPerformanceReportSuccessAction
  | CreatePerformanceReportAction
  | CreatePerformanceReportSuccessAction
  | SavePerformanceReportAction
  | SubmitPerformanceReportAction
  | SavePerformanceReportSuccessAction
  | SubmitPerformanceReportSuccessAction
  | UpdatePerformanceReportAction
  | SetSelectedClientIdAction
  | SubmitTabPerformanceReportSuccessAction
  | LoadCompletedPerformanceReportTabsSuccessAction
  | ClearLoadingReportAction
  | UnlockPerformanceReportAction
  | UnlockPerformanceReportSuccessAction
  | LoadDealerReportsSuccessAction
  | LoadAllDealerReportsSuccessAction
  | LoadAllDealerReportsAction
  | ClosePerformanceReportAction
  | SubmitTabPerformanceReportAction
  | RollupPerformanceReportAction
  | RollupPerformanceReportSuccessAction
  | RollupPerformanceReportFailureAction;